module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": _vm.title,
      "pop": true
    }
  }, [_c('z-backForm', {
    attrs: {
      "name": 'back-taskType',
      "align": true
    },
    on: {
      "save": _vm.saveSet,
      "cancel": _vm.backset
    }
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("类型名称")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: ([2, 15]),
      expression: "[2,15]"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.name),
      expression: "sub.name"
    }],
    staticClass: "top-choose",
    attrs: {
      "rule": "limit",
      "placeholder": "请填写名称"
    },
    model: {
      value: (_vm.sub.name),
      callback: function($$v) {
        _vm.$set(_vm.sub, "name", $$v)
      },
      expression: "sub.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("请输入2-15个字符,且不允许出现空格")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item area"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("类型说明")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: ('类型说明'),
      expression: "'类型说明'"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.describe),
      expression: "sub.describe"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sub.describe),
      expression: "sub.describe"
    }],
    attrs: {
      "rule": "reason describe_limit",
      "placeholder": "请输入任务类型说明"
    },
    domProps: {
      "value": (_vm.sub.describe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sub, "describe", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("周期范围")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "group",
      rawName: "v-group"
    }],
    staticClass: "back-wrap back-range"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.min_date),
      expression: "sub.min_date"
    }],
    staticClass: "top-choose small",
    attrs: {
      "rule": "scope number"
    },
    model: {
      value: (_vm.sub.min_date),
      callback: function($$v) {
        _vm.$set(_vm.sub, "min_date", $$v)
      },
      expression: "sub.min_date"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("天")])], 2), _vm._v(" "), _c('span', [_vm._v("~")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.max_date),
      expression: "sub.max_date"
    }],
    staticClass: "top-choose small",
    attrs: {
      "rule": "scope number"
    },
    model: {
      value: (_vm.sub.max_date),
      callback: function($$v) {
        _vm.$set(_vm.sub, "max_date", $$v)
      },
      expression: "sub.max_date"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("天")])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("任务金额")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "group",
      rawName: "v-group"
    }],
    staticClass: "back-wrap back-range"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.min_bonus),
      expression: "sub.min_bonus"
    }],
    staticClass: "top-choose small",
    attrs: {
      "rule": "scope number"
    },
    model: {
      value: (_vm.sub.min_bonus),
      callback: function($$v) {
        _vm.$set(_vm.sub, "min_bonus", $$v)
      },
      expression: "sub.min_bonus"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.task_curr.currency_name))])], 2), _vm._v(" "), _c('span', [_vm._v("~")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.max_bonus),
      expression: "sub.max_bonus"
    }],
    staticClass: "top-choose small",
    attrs: {
      "rule": "scope number"
    },
    model: {
      value: (_vm.sub.max_bonus),
      callback: function($$v) {
        _vm.$set(_vm.sub, "max_bonus", $$v)
      },
      expression: "sub.max_bonus"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.task_curr.currency_name))])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title",
    class: {
      add: _vm.sub.file_flag
    }
  }, [_vm._v("上传文档")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap check"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": function($event) {
        _vm.hideError('file')
      }
    },
    model: {
      value: (_vm.sub.file_flag),
      callback: function($$v) {
        _vm.$set(_vm.sub, "file_flag", $$v)
      },
      expression: "sub.file_flag"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.file_flag),
      expression: "sub.file_flag"
    }]
  }, [_vm._v("是否需要上传文档")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sub.file_flag),
      expression: "sub.file_flag"
    }],
    staticClass: "file-wrap",
    on: {
      "click": function($event) {
        _vm.hideError('file')
      }
    }
  }, [_c('z-scrollDiv', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.file_str),
      expression: "file_str"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: ('上传文档'),
      expression: "'上传文档'"
    }],
    ref: "file",
    staticClass: "file-list",
    attrs: {
      "rule": _vm.file_rule
    }
  }, [_vm._l((_vm.files), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "file-item"
    }, [_c('span', [_vm._v(_vm._s(item.tpl_doc_name))]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.removeFlie(item, index)
        }
      }
    }, [_vm._v("移除")])])
  }), _vm._v(" "), _vm._l((_vm.sub.fileList), function(item, index) {
    return _c('div', {
      key: item.name,
      staticClass: "file-item"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.sub.fileList.splice(index, 1)
        }
      }
    }, [_vm._v("移除")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "back-btn ",
    on: {
      "click": function($event) {
        _vm.hideError('file')
      }
    }
  }, [_vm._v("添加\n                                 "), _c('input', {
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        _vm.addUpItem($event)
      }
    }
  })])], 1)])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-9b664e5c!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/setting/page-taskType-add.vue
// module id = 776
// module chunks = 1